import { render, staticRenderFns } from "./MoveConfirmModal.vue?vue&type=template&id=fa13eca4&scoped=true&"
import script from "./MoveConfirmModal.vue?vue&type=script&lang=js&"
export * from "./MoveConfirmModal.vue?vue&type=script&lang=js&"
import style0 from "./MoveConfirmModal.vue?vue&type=style&index=0&id=fa13eca4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa13eca4",
  null
  
)

export default component.exports